import { Injectable } from '@angular/core';
import { SingleDepartmentService } from 'src/app/shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class PlasticDepartmentService extends SingleDepartmentService {
  readonly MACHINE_TYPE_ID = 1;
  readonly DEPARTMENT_ID = 4;
  readonly WORK_ORDER_TYPE_ID = 14;
  readonly NAME = 'Plastics';

  private _departmentId: number;
  set departmentId(value: number) {
    this._departmentId = value;
  }
  get departmentId(): number {
    return this._departmentId;
  }

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('PlasticChief') ||
      roles.includes('PlasticAdmin') ||
      roles.includes('PlasticViewer') ||
      roles.includes('PlasticLeaderMachine') ||
      roles.includes('PlasticLeaderTrimming') ||
      roles.includes('PlasticEngineer')
    ) {
      this.router.navigate(['/sb/plastic/machine']);
      return true;
    }

    if (
      roles.includes('PlasticInspectionMachine') ||
      roles.includes('PlasticInspectionTrimming')
    ) {
      this.router.navigate(['/sb/plastic/inspection']);
      return true;
    }
    return false;
  }
}
